// Angel One SmartAPI Configuration

export const EXCHANGES = {
  NSE: 'NSE',
  BSE: 'BSE',
  NFO: 'NFO',
  BFO: 'BFO',
  MCX: 'MCX',
  CDS: 'CDS',
};

export const EXCHANGE_LABELS = {
  NSE: 'NSE',
  BSE: 'BSE',
  NFO: 'NSE F&O',
  BFO: 'BSE F&O',
  MCX: 'MCX',
  CDS: 'Currency',
};

export const PRODUCT_TYPES = {
  DELIVERY: 'DELIVERY',
  CARRYFORWARD: 'CARRYFORWARD',
  MARGIN: 'MARGIN',
  INTRADAY: 'INTRADAY',
  BO: 'BO',
};

export const PRODUCT_LABELS = {
  DELIVERY: 'CNC (Delivery)',
  CARRYFORWARD: 'NRML (Carry Forward)',
  MARGIN: 'Margin',
  INTRADAY: 'MIS (Intraday)',
  BO: 'Bracket Order',
};

export const ORDER_TYPES = {
  MARKET: 'MARKET',
  LIMIT: 'LIMIT',
  STOPLOSS_LIMIT: 'STOPLOSS_LIMIT',
  STOPLOSS_MARKET: 'STOPLOSS_MARKET',
};

export const ORDER_TYPE_LABELS = {
  MARKET: 'Market',
  LIMIT: 'Limit',
  STOPLOSS_LIMIT: 'SL',
  STOPLOSS_MARKET: 'SL-M',
};

export const TRANSACTION_TYPES = {
  BUY: 'BUY',
  SELL: 'SELL',
};

export const VARIETIES = {
  NORMAL: 'NORMAL',
  STOPLOSS: 'STOPLOSS',
  AMO: 'AMO',
  ROBO: 'ROBO',
};

export const DURATIONS = {
  DAY: 'DAY',
  IOC: 'IOC',
};

export const CANDLE_INTERVALS = {
  ONE_MINUTE: 'ONE_MINUTE',
  THREE_MINUTE: 'THREE_MINUTE',
  FIVE_MINUTE: 'FIVE_MINUTE',
  TEN_MINUTE: 'TEN_MINUTE',
  FIFTEEN_MINUTE: 'FIFTEEN_MINUTE',
  THIRTY_MINUTE: 'THIRTY_MINUTE',
  ONE_HOUR: 'ONE_HOUR',
  ONE_DAY: 'ONE_DAY',
};

export const INTERVAL_LABELS = {
  ONE_MINUTE: '1m',
  THREE_MINUTE: '3m',
  FIVE_MINUTE: '5m',
  TEN_MINUTE: '10m',
  FIFTEEN_MINUTE: '15m',
  THIRTY_MINUTE: '30m',
  ONE_HOUR: '1H',
  ONE_DAY: '1D',
};

// WebSocket V2 modes
export const WS_MODES = {
  LTP: 1,    // Last Traded Price only
  QUOTE: 2,  // LTP + OHLC + volume
  SNAP: 3,   // Full snapshot with depth
};

// Key indices for market strip
export const KEY_INDICES = [
  { name: 'NIFTY 50', token: '99926000', exchange: 'NSE' },
  { name: 'BANK NIFTY', token: '99926009', exchange: 'NSE' },
  { name: 'SENSEX', token: '99919000', exchange: 'BSE' },
  { name: 'NIFTY IT', token: '99926013', exchange: 'NSE' },
  { name: 'NIFTY FIN', token: '99926037', exchange: 'NSE' },
];

// GTT rule types
export const GTT_TYPES = {
  SINGLE: 'STOPLOSS',
  OCO: 'OCO',
};

// Order statuses
export const ORDER_STATUSES = {
  COMPLETE: 'complete',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  OPEN: 'open',
  PENDING: 'pending',
  TRIGGER_PENDING: 'trigger pending',
};

export const STATUS_COLORS = {
  complete: 'mint',
  rejected: 'gold',
  cancelled: 'frost',
  open: 'accent',
  pending: 'accent',
  'trigger pending': 'accent',
};

// SENSEX Algo-specific constants
export const SENSEX_CONFIG = {
  TOKEN: '99919000',
  EXCHANGE: 'BSE',
  OPTION_EXCHANGE: 'BFO',
  LOT_SIZE: 10,
  STRIKE_INTERVAL: 100,
  EXPIRY_DAY: 5, // Friday (JS Date: 0=Sun, 5=Fri)
  NAME: 'SENSEX',
  SYMBOL: 'SENSEX',
};

export const ALGO_MODES = {
  MANUAL: 'MANUAL',
  SEMI_AUTO: 'SEMI_AUTO',
  FULL_AUTO: 'FULL_AUTO',
};

export const ALGO_MODE_LABELS = {
  MANUAL: 'Manual (View Signals)',
  SEMI_AUTO: 'Semi-Auto (Confirm)',
  FULL_AUTO: 'Full Auto (Execute)',
};

export const REGIME_COLORS = {
  LOW_VOL: { bg: 'bg-blue-500/20', text: 'text-blue-400', label: 'Low Volatility' },
  NORMAL: { bg: 'bg-emerald-500/20', text: 'text-emerald-400', label: 'Normal' },
  HIGH_VOL: { bg: 'bg-amber-500/20', text: 'text-amber-400', label: 'High Volatility' },
  EXPANSION: { bg: 'bg-red-500/20', text: 'text-red-400', label: 'Expansion' },
};
